<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				option:[{
					value: '30299',
					label: '建设行政事业性收费收入'
				},{
					value: '39900',
					label: '其他收入'
				},{
					value: '30221',
					label: '水利建设专项收入'
				}],
				option1:[{
					value: '227',
					label: '中国护照'
				},{
					value: '228',
					label: '城镇退役士兵自谋职业证'
				},{
					value: '100',
					label: '单位'
				},{
					value: '101',
					label: '组织机构代码证'
				},{
					value: '199',
					label: '其他证件'
				},{
					value: '200',
					label: '个人'
				},{
					value: '201',
					label: '居民身份证'
				},{
					value: '202',
					label: '军官证'
				},{
					value: '203',
					label: '武警警官证'
				},{
					value: '204',
					label: '士兵证'
				},{
					value: '205',
					label: '军队离退休干部证'
				},{
					value: '206',
					label: '残疾人证'
				},{
					value: '207',
					label: '残疾军人证（1-8级）'
				},{
					value: '208',
					label: '外国护照'
				},{
					value: '209',
					label: '港澳同胞回乡证'
				},{
					value: '210',
					label: '港澳居民来往内地通行证'
				},{
					value: '211',
					label: '台胞证'
				},{
					value: '212',
					label: '中华人民共和国往来港澳通行证'
				},{
					value: '213',
					label: '台湾居民来往大陆通行证'
				},{
					value: '214',
					label: '大陆居民往来台湾通行证'
				},{
					value: '215',
					label: '外国人居留证'
				},{
					value: '216',
					label: '外交官证'
				},{
					value: '217',
					label: '领事馆证'
				},{
					value: '218',
					label: '海员证'
				},{
					value: '219',
					label: '香港身份证'
				},{
					value: '220',
					label: '台湾身份证'
				},{
					value: '221',
					label: '澳门身份证'
				},{
					value: '223',
					label: '高校毕业生自主创业证'
				},{
					value: '222',
					label: '外国人身份证件'
				},{
					value: '224',
					label: '就业失业登记证'
				},{
					value: '225',
					label: '退休证'
				},{
					value: '226',
					label: '离休证'
				},{
					value: '299',
					label: '其他个人证件'
				},{
					value: '233',
					label: '外国人永久居留证'
				},{
					value: '102',
					label: '营业执照'
				},{
					value: '234',
					label: '就业创业证'
				},{
					value: '291',
					label: '医学出生证明'
				},],
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			tableDataII:{
				type: Object,
				default: {},
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
			this.$nextTick(()=>{
			})
		},
		methods: {
			selectchange(e){
				this.option.map(item=>{
					if(item.value==e.tysl_0_x_1.cellVal){
						e.tysl_0_x_1a.cellVal = item.label
					}
				})
				if(e.tysl_0_x_1.cellVal=='30299'){
					e.tysl_0_x_2a.option1 = [{
						value: '302210400',
						label: '地方水利建设基金'
					}]
				}else if(e.tysl_0_x_1.cellVal=='39900'){
					e.tysl_0_x_2a.option1 = [{
						value: '399001010',
						label: '工会筹备金'
					}]	
				}else if(e.tysl_0_x_1.cellVal=='30221'){
					e.tysl_0_x_2a.option1 = [{
						value: '302990200',
						label: '城镇垃圾差处理费'
					}]	
				}
			},
			selectchangetwo(e){
				e.tysl_0_x_2a.option1.map(item=>{
					if(item.value==e.tysl_0_x_2.cellVal){
						e.tysl_0_x_2a.cellVal = item.label
					}
				})
				if(e.tysl_0_x_2.cellVal=='302210400'){
					e.tysl_0_x_3a.option2 = [{
						value: '3022104002350001',
						label: '企事业及个体（0.09%）'
					},{
						value: '3022104002350002',
						label: '银行保险企业'
					},{
						value: '3022104002350003',
						label: '非银行金融机构'
					},{
						value: '3022104002350004',
						label: '企事业及个体（0.07%）'
					},{
						value: '3022104002350005',
						label: '外商投资企业'
					},{
						value: '3022104002350006',
						label: '企事业及个体（0.1%）'
					},{
						value: '3022104002350007',
						label: '企事业及个体（0.05%）'
					},{
						value: '3022104002350008',
						label: '供水站'
					},{
						value: '3022104002350009',
						label: '外资银行、外资保险企业'
					},{
						value: '3022104002610901',
						label: '征占土地水利建设基金：水浇地'
					},{
						value: '3022104002610902',
						label: '征占土地水利建设基金：水田'
					},{
						value: '3022104002610903',
						label: '征占土地水利建设基金：旱地'
					},{
						value: '3022104002610904',
						label: '征占土地水利建设基金：其他土地'
					},{
						value: '3022104002610001',
						label: '企事业单位及个体经营者'
					},{
						value: '3022104002610002',
						label: '银行（含信用社）、保险业'
					},{
						value: '3022104002610003',
						label: '信托投资公司、财务公司等非银行金融机构'
					},{
						value: '3022104002610004',
						label: '阶段性降费'
					},{
						value: '3022104002610005',
						label: '中国（陕西）自贸区和西安自主创新区'
					},{
						value: '3022104001610301',
						label: '征占土地水利建设基金：水浇地'
					},{
						value: '3022104001610302',
						label: '征占土地水利建设基金：水田'
					},{
						value: '3022104001610303',
						label: '征占土地水利建设基金：旱地'
					},{
						value: '3022104001610304',
						label: '征占土地水利建设基金：其他土地'
					},]
				}else if(e.tysl_0_x_2.cellVal=='399001010'){
					e.tysl_0_x_3a.option2 = [{
						value: '3990010102320001',
						label: '工会经费收入-1'
					},{
						value: '3990010102320002',
						label: '工会经费0.1%'
					},{
						value: '3990010102320003',
						label: '工会经费0.2%'
					},{
						value: '3990010102320004',
						label: '工会经费0.4%'
					},{
						value: '3990010102320005',
						label: '工会经费0.6%'
					},{
						value: '3990010102320006',
						label: '工会经费0.8%'
					},{
						value: '3990010102320007',
						label: '工会经费2%'
					},{
						value: '3990010102320008',
						label: '工会经费35'
					},{
						value: '3990010102320009',
						label: '工会经费0.5%'
					},{
						value: '3990010102320010',
						label: '工会经费0.7%'
					}]	
				}else if(e.tysl_0_x_2.cellVal=='302990200'){
					e.tysl_0_x_3a.option2 = [{
						value: '3043313001510002',
						label: '城镇垃圾处理费[地市100%]'
					}]	
				}
			},
			selectchangethree(e){
				e.tysl_0_x_3a.option2.map(item=>{
					if(item.value==e.tysl_0_x_3.cellVal){
						e.tysl_0_x_3a.cellVal = item.label
					}
				})
			},
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},	
			headchange(){
				this.$emit("headchange",this.headobj)
			},
			fordelete(index){
					if(this.tableDataI.length<3){
						return false
					}
					if(this.$notemptyandnull(this.tableDataI[index]['tysl_0_x_1'].id)){
						this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])) )
					}
				this.tableDataI.splice(index,1)	
				this.$emit('delCellsCode',this.delCells)
				},
				foraddhang() {
					let endobj=this.tableDataI[this.tableDataI.length-1]
					this.tableDataI.pop()
					this.tableDataI.push({
						tysl_0_x_1: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_1",
							cellType: "0",
							cellVal: "30221",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_1a: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_1a",
							cellType: "0",
							cellVal: "水利建设专项收入",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_2: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_2",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_2a: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_2a",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_3: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_3",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_3a: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_3a",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_4: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_4",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_5: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_5",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_6: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_6",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_7: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_7",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_8: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_8",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_9: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_9",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_10: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_10",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_11: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_11",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_12: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_12",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_13: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_13",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_14: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_14",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_15: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_15",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_16: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_16",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_17: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_17",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_18: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_18",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						},
						tysl_0_x_19: {
							cellCode: "tysl_0_"+(parseFloat(this.tableDataI.length)+1)+"_19",
							cellType: "0",
							cellVal: "",
							updateDesc:"",
							map:{}
						}
					})
					this.tableDataI.push(endobj)
				
					this.selectchange(this.tableDataI[this.tableDataI.length-2])
				}
		},
		
	}
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
